"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ModalApplicationDetails = _interopRequireDefault(require("./ModalApplicationDetails"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  name: 'ApplicationDetailsModal',
  components: {
    ModalApplicationDetails: _ModalApplicationDetails.default
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    application: {
      type: Object,
      default: null
    }
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  }
};